import "./TyreServices.module.css";
import Header from "@/reusable_sections/Header";
import MenuCategories from "./sections/MenuCategories";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function TyreServicesPage() {
  return <div>
      <Header />
      <MenuCategories />
      <CommonInquiries />
      <Footer />
    </div>;
}